/// <reference path='common.ts' />
/// <reference path='fetch.ts' />
/// <reference path='element_form.ts' />

/**
 * エレメントの値を変更した際の処理を定義します。
 *
 * 属性
 * data-change-confirm: 変更した際に表示される確認ダイアログのメッセージ
 * data-change-fetch: 変更された際にフェッチするURL
 * data-change-data: フェッチ結果の代わりに使用されるデータ（JSON形式）
 * data-change-method: フェッチする際のメソッド（省略時はGET）
 * data-change-enctype: フェッチする際に送信するContent-Type（GETメソッドの場合はapplication/x-www-form-urlencoded、それ以外場合はapplication/jsonがデフォルト）
 * data-change-form: フェッチする際に付与するパラメータが格納されているフォームのセレクタ（値が空の場合は親フォーム）フェッチしない場合はパラメータが値として利用される
 * data-change-reset: 変更した際もしくはフェッチに成功した際にリセットするフォームのセレクタ（値が省略されている場合はdata-change-formの値を使う）
 * data-change-param: フェッチする際に送信するパラメータ（JSON形式）（data-change-formとは排他）
 * data-change-bind: フェッチ結果を属性として格納するエレメントのセレクタ（値が空の場合は当該エレメント）
 * data-change-bind-attribute: フェッチ結果を格納する属性（省略時はdata-bind）
 * data-change-bind-arg: フェッチ結果を格納する変数（省略時は展開する）
 * data-change-bind-merge: フェッチ結果を元のdata-bindとマージする
 * data-change-redirect: 変更した際もしくはフェッチに成功した際に遷移するURL
 * data-change-alert: 変更した際もしくはフェッチに成功した際に表示するダイアログのメッセージ
 * data-change-message: 変更した際もしくはフェッチに成功した際に表示するメッセージ
 * data-change-open: 変更した際もしくはフェッチに成功した際に開くダイアログのセレクタ（値が空の場合は親ダイアログ）
 * data-change-close: 変更した際もしくはフェッチに成功した際に閉じるダイアログのセレクタ（値が空の場合は親ダイアログ）
 * data-change-click: 変更した際もしくはフェッチに成功した際に変更するエレメントのセレクタ
 * data-change-bind-reload: 変更した際もしくはフェッチに成功した際にリロードするdata-bind-fetch属性があるエレメントのセレクタ
 * data-change-table-reload: 変更した際もしくはフェッチに成功した際にリロードするテーブルエレメントのセレクタ
 * data-change-download: バイナリデータをフェッチに成功した場合に保存するファイル名
 * data-change-cache-use: キャッシュした内容をフェッチの代わりに使用する場合（値をキーとし、設定していない場合はフェッチURLをキーとする）
 * data-change-cache-set: フェッチした内容をキャッシュする（値をキーとし、設定していない場合はフェッチURLをキーとする）
 * data-change-cache-clear: 変更した際もしくはフェッチに成功した際にキャッシュをクリアする（値をキーとし、設定していない場合はフェッチURLをキーとする）
 * data-change-copy: フェッチした内容をコピーして設定するエレメントのセレクタ
 *
 * イベント
 * fetch: 通信が完了した場合（detailはrequestとresponseのPromise）
 * fetch-error: 通信中にエラーが発生した場合（detailはrequestとエラー内容）
 */
class HaoriChange {
  /**
   * エレメントの変更処理を実行します。
   *
   * @param target 変更イベントもしくは対象エレメント
   */
  static async change(target: Event | Element) {
    let event: Event | null;
    let element: Element;
    if (target instanceof Event) {
      element = <Element>target.target;
      event = target;
    } else {
      element = <Element>target;
      event = null;
    }

    if (element.hasAttribute('data-disabled-change-fetch')) {
      return;
    }

    let result = await Haori.hasAttribute(element, 'data-change-confirm', async (element, value) => {
      event?.preventDefault();
      return await Haori.confirm(value);
    });
    if (result === false) {
      return;
    }

    let fetch = new HaoriFetch();
    fetch.setParams(element, 'data-change');
    let fetched = Haori.hasAttribute(element, 'data-change-fetch', (target, url) => {
      event?.preventDefault();
      fetch.fetch(url, element);
      return true;
    });
    if (fetched === null) {
      let bind: any = null;
      Haori.hasAttribute(element, 'data-change-data', (target, data) => {
        bind = JSON.parse(data);
      });
      let form: HTMLFormElement | null = null;
      Haori.hasAttribute(element, 'data-change-form', (element, value) => {
        if (value == '') {
          form = <HTMLFormElement>element.closest('form');
        } else {
          form = <HTMLFormElement>Haori.querySelector(value);
        }
      });
      if (form) {
        bind = HaoriForm.getValues(form);
      }
      fetch.receive(bind).then((result) => {
        if (result) {
          event?.preventDefault();
        }
      });
    }
  }
}

document.body.addEventListener('change', HaoriChange.change);
